let GCN_SERVICES = process.env.VUE_APP_GCN_SERVICES || '/gcn-services/api';
const VUE_APP_PEX = process.env.VUE_APP_PEX || '/pex';

const isDevMode =
  process && process.env && process.env.NODE_ENV === 'development';

if (isDevMode) {
  GCN_SERVICES = 'http://localhost/gcn-services/api';
}

export const VUE_APP_GCN_SERVICES = GCN_SERVICES;
export { VUE_APP_PEX };

export const FL_SIM_NAO = {
  SIM: 'S',
  NAO: 'N',
};

export const FL_NAO = FL_SIM_NAO.NAO;
export const FL_SIM = FL_SIM_NAO.SIM;

export enum TipoObra {
  ARTIGO_PERIODICO = 1,
  CAPITULO_LIVRO = 2,
  COLECAO_PERIODICO = 3,
  LIVRO = 4,
  PRODUCAO_CIENTIFICA = 5,
}

export const CD_SISTEMA = 132;
